export default __webpack_public_path__ + "static/media/axia_coin_wallet.70f5b512.png";